export default {
  ansTypeMap: {//几个题一组
    FlashDiamond: 1,
    ImageTransform: 1,
    BlockRotate: 1,
    FillWall: 1,
    GroundPerspective: 1,
    CubeComplement: 1,
    E808A: 1,
    E808APlus: 1,
    E808B: 12,
    E808B2: 12,
    E808C: 12,
    E808D: 5,
    E808E: 1,
    E808EPlus: 1,
    LogicalReasoning: 1,
    Moss: 1,
    MossCopy: 1,
    Moss5: 1,
    MossMissing4: 1,
    MossMissing5: 1,
    QuickScale: 1,
    WhackAMole: 1,
    HarderMoss: 1,
    E808D2: 4,
    E808B3: 4,
    E808B4: 4,
    CodeMath: 1,
    FastMemory: 1,
    Seesaw: 1,
    Unfolding3D: 1,
    PriceCalculate: 1,
    FlashingRect: 1,
    RotateMatrix: 1,
    ColorRotateMatrix: 1,
    RandomDice: 1,
    SequenceBacktracking: 1,
    NeuralNetwork: 1,
    LogicalReasoning2D: 1,
    TextLogicalReasoning: 1,
    PlaneTurntable: 1,
    StereoSameEdge: 1,
    GraphMatch: 1,
    CircuitRouting: 1,
    DigitSymbolReaction: 1,
    ImageSequenceMemory: 1,
    LogicalTransformer2D: 1,
    LogicalTransformerSector: 1,
    LogicalTransformerSectorPlus: 1,
    F3DScaleA: 1,
    F3DScaleB: 1,
    F3DScaleC: 1,
    TaiChiA: 1,
    TaiChiB: 1,
    StereoProjection: 1,
    Knot: 1,
    GraphMemory: 1,
    EarTraining808: 1,
    DNASequence: 1,
    ColorGridMemory: 1,
    ColorHeightProjection: 1,
    NineGridMirrorInference: 1,
    HanoiTowerInference: 1,
    MechanicalArmPose: 1,
    MechanicalArmPosePractice: 1,
    OpticalPathInference: 1,
  },
  ansModeMap: {//是否显示答题卡
    FlashDiamond: 0,
    ImageTransform: 0,
    BlockRotate: 0,
    FillWall: 0,
    GroundPerspective: 0,
    CubeComplement: 0,
    E808A: 1,
    E808APlus: 1,
    E808B: 1,
    E808B2: 1,
    E808C: 1,
    E808D: 1,
    E808E: 1,
    E808EPlus: 1,
    LogicalReasoning: 0,
    Moss: 0,
    MossCopy: 0,
    Moss5: 0,
    MossMissing4: 0,
    MossMissing5: 0,
    QuickScale: 1,
    WhackAMole: 0,
    HarderMoss: 0,
    E808D2: 1,
    E808B3: 1,
    E808B4: 1,
    CodeMath: 0,
    FastMemory: 0,
    Seesaw: 0,
    Unfolding3D: 0,
    PriceCalculate: 0,
    FlashingRect: 0,
    RotateMatrix: 0,
    ColorRotateMatrix: 0,
    RandomDice: 0,
    SequenceBacktracking: 0,
    NeuralNetwork: 0,
    LogicalReasoning2D: 0,
    TextLogicalReasoning: 0,
    PlaneTurntable: 0,
    StereoSameEdge: 0,
    GraphMatch: 0,
    CircuitRouting: 0,
    DigitSymbolReaction: 1,
    ImageSequenceMemory: 0,
    LogicalTransformer2D: 0,
    LogicalTransformerSector: 0,
    LogicalTransformerSectorPlus: 0,
    F3DScaleA: 1,
    F3DScaleB: 1,
    F3DScaleC: 1,
    TaiChiA: 0,
    TaiChiB: 0,
    StereoProjection: 0,
    RandomForest: 0,
    Knot: 0,
    GraphMemory: 0,
    EarTraining808: 1,
    DNASequence: 1,
    ColorGridMemory: 0,
    ColorHeightProjection: 0,
    NineGridMirrorInference: 0,
    HanoiTowerInference: 0,
    MechanicalArmPose: 0,
    MechanicalArmPosePractice: 1,
    OpticalPathInference: 0,
  },
  infoMap: {
    "OpticalPathInference": {
      "name": "黑盒光路推理",
      "desc": "根据已知入射和射出案例，推断黑盒内部光路并判断新光线的射出方向",
      "tags": ["逻辑推理", "光路分析", "规律归纳"],
      "hightlight": "2026新增题型",
      "describe": [
        "每题给出若干组已知入射与射出案例，以及一组新的入射光线。",
        "请推断黑盒内光学元件的组合规律，并从选项中选择正确的射出路径。"
      ],
      "link": ""
    },
    "MechanicalArmPose": {
      "name": "机械臂水瓶姿态",
      "desc": "根据机械臂关节旋转指令，判断水瓶的最终姿态",
      "tags": ["立体思维", "空间想象", "顺序推理"],
      "hightlight": "2026新增题型",
      "describe": [
        "每题使用相同的机械臂初始状态，请按题面顺序执行关节旋转指令。",
        "从 A 到 H 八种固定水瓶姿态中选择最终结果。共 30 题，指令数量会逐步增加。"
      ],
      "link": ""
    },
    "MechanicalArmPosePractice": {
      "name": "机械臂水瓶姿态练习",
      "desc": "根据机械臂关节旋转指令，判断水瓶的最终姿态",
      "tags": ["立体思维", "空间想象", "顺序推理"],
      "hightlight": "2026新增题型",
      "describe": [
        "每题使用相同的机械臂初始状态，请按题面顺序执行关节旋转指令。",
        "从 A 到 H 八种固定水瓶姿态中选择最终结果。共 30 题，指令数量会逐步增加。"
      ],
      "link": ""
    },
    "ImageSequenceMemory": {
      "name": "图形记忆力",
      "desc": "记住依次闪烁的图形，并按原顺序点击",
      "tags": ["工作记忆", "顺序记忆", "专注力"],
      "hightlight": "2026新增题型",
      "describe": [
        "每题先展示 9 个图形，其中若干图形会依次闪烁。",
        "闪烁结束后，请在答题区按原顺序点击图形。",
        "共 30 题，限时 5 分钟；闪烁数量会从 3 个逐步增加到 8 个。"
      ],
      "link": ""
    },
    "DigitSymbolReaction": {
      "name": "数字图形反应",
      "desc": "根据数字与图形的对应关系，快速点击正确图形",
      "tags": ["反应速度", "视觉搜索", "持续专注"],
      "hightlight": "2026新增题型",
      "describe": [
        "先记住数字 1 至 9 与九种图形的对应关系。",
        "正式测试共 300 题，限时 5 分钟。每题看到数字后，立即点击对应图形。",
        "点击后会直接进入下一题，不能返回修改。请兼顾速度和准确率。"
      ],
      "link": ""
    },
    "NineGridMirrorInference": {
      "name": "九宫镜像推断",
      "desc": "先看 4 次变换图例，再推断题目图形和 PASS 结果",
      "tags": ["逻辑推理", "规则判断", "一心二用"],
      "hightlight": "2026预测题",
      "describe": [
        "点击播放按钮后，会依次展示变换 1~4 的图例，每次只显示 2 秒，总共只能看 4 次。",
        "请根据图例判断 4 个变换分别是什么操作，再把题目图形依次执行变换 1~4，点出最终黑格分布；如果任意一步与原图完全相同，还要点击 PASS。"
      ],
      "link": ""
    },
    "ColorHeightProjection": {
      "name": "彩色高度投影",
      "desc": "根据彩色高度图和箭头方向，判断对应侧视轮廓结果",
      "tags": ["立体思维", "空间想象力", "推断力"],
      "hightlight": "2026预测题",
      "describe": [
        "题干中的 3x3 彩色方格表示 3x3x3 方块体的高度分布：黄色是 0，红色是 1，绿色是 2，蓝色是 3。",
        "请根据箭头表示的观察方向，在右侧 4 个轮廓图中选出正确结果；旋转后相同也算正确，但镜像不算。"
      ],
      "link": ""
    },
    "HanoiTowerInference": {
      "name": "汉诺塔推理",
      "desc": "先推断每列计算规则，再在规则交换后计算右侧四列结果",
      "tags": ["推断力", "计算力", "专注力"],
      "hightlight": "2026预测题",
      "describe": [
        "左侧 4 列汉诺塔下方的数字，分别由红环数、蓝环数、红蓝乘积、红蓝差值中的某一条规则计算得到。",
        "请先推断每列规则，再按照中间给出的交换位置，把交换后的规则应用到右侧 4 列，并填写四个问号处的数字。"
      ],
      "link": ""
    },
    "ColorGridMemory": {
      "name": "彩色方格记忆",
      "desc": "记忆红蓝闪烁方格，并按顺序点击红色格子位置",
      "tags": ["记忆力", "专注力", "判断力"],
      "hightlight": "2026预测题",
      "describe": [
        "点击开始播放后，网格会随机闪烁红色和蓝色格子。",
        "请在全部闪烁结束后，只按红色格子出现的先后顺序依次点击对应位置。"
      ],
      "link": ""
    },
    "GraphMemory": {
      "name": "动态的舒尔特方格",
      "desc": "记住黑方格的位置，判断与上上一个是否相同",
      "tags": ["图形处理能力", "记忆力"],
      "hightlight": '2025真题题型'
    },
    "ColorRotateMatrix": {
      "name": "彩色矩阵旋转",
      "desc": "从选项中选出经平面旋转后与题目图形一致的图形选项",
      "tags": ["图形处理能力", "记忆力"],
      "hightlight": '2023真题题型'

    },
    "EarTraining808": {
      "name": "试听练耳",
      "desc": "找到连续音效相同或空心正方形",
      "tags": ["图形处理", "声音识别", "一心二用"],
      "hightlight": '2025真题题型',
      "describe": [
        '答题过程中，任务一和任务二同时出现，你需要同时注意视觉目标和声音目标，它们可能单独出现，也可能同时出现，在看到四个“x”组成的空心正方形，或听到音高相同的声音时，要在保证准确的情况下尽快点击按钮，当它们同时出现时，你也只需要点击一下。',
      ],
      link: ''
    },
    "DNASequence": {
      "name": "DNA序列",
      "desc": "根据已知配对规则判断 DNA 片段是否正确",
      "tags": ["逻辑处理能力", "专注力"],
      "hightlight": "2025新题型",
      "describe": [
        "题干给出 4 组规则（如 A-N），表示 A 只能和 N 配对，N 也只能和 A 配对。",
        "再给出 6 组要检查的配对，只要有一组不符合规则，就判为 false。",
        "没出现在规则里的字母，默认配对正确；一组中的左右位置互换不影响判断。"
      ],
      link: ""
    },
    "BlockRotate": {
      "name": "几何旋转",
      "desc": "找到多个与图例完全相同的立体图形",
      "tags": ["图形处理能力"],
      "hightlight": '2024真题题型',
      "describe": [
        '每个题目中会呈现一个有 9-10 个小立方体构成的立体图形，选项中会呈现六个类似的立体图形，其中只有一个或两个是由题目中的图形旋转得到的，它与题目中的立体图形完全相同，只是呈现的角度不同。',
        '请你想象题目中图形旋转后，能够得到哪个图形，请把它选出来。请在保证正确性的情况下尽快作答。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E5%87%A0%E4%BD%95%E6%97%8B%E8%BD%AC-new.mp4'
    },
    "GroundPerspective": {
      "name": "地面视角（我的世界）",
      "desc": "想象站在左侧立体环境的红点处，并从右侧4个选项中选出可能的视角",
      "tags": ["图形处理能力"],
      "hightlight": '2023真题题型'
    },
    "RandomDice": {
      "name": "随机骰子",
      "desc": "根据左侧图形，找到右侧相同图案的图形",
      "tags": ["记忆力"],
      "hightlight": '2024真题题型'
    },
    "Moss": {
      "name": "摩斯密码(3位)",
      "desc": "根据图例摩斯密码特征，选择出题目中的符号代码",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2022真题题型',
      "describe": [
        '题目中，上方有由 "." "|" "-" 三种元素组合而成 10 种符号，每组符号对应不同的代码。下方 4 个符号取自于上方的 10 种符号，请你尽可能的快得找到下方 4 个符号对应的代码，并进行勾选。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/mosi-new.mp4'
    },
    "FlashingRect": {
      "name": "方格闪烁",
      "desc": "快速找到并点击缺口",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2024真题题型'
    },
    "RotateMatrix": {
      "name": "矩阵旋转",
      "desc": "题目中将给出一个平面图形，选出经平面旋转后与题目图形一致的图形选项",
      "tags": ["图形处理能力", "记忆力"],
      "hightlight": '2024真题题型'
    },
    "StereoscopicSectionExam": {
      "name": "3D切面(考试模式)",
      "desc": "找到无法通过一次性切割图例得到的图形",
      "tags": ["图形处理能力"],
      "hightlight": '2024真题自主学习'
    },
    "NeuralNetwork": {
      "name": "神经网络",
      "desc": "根据神经元规则对图形进行颜色、大小、方向等变化，得到输出图形",
      "tags": ["图形处理能力", "记忆力"],
      "hightlight": '2024真题题型'
    },
    "LogicalReasoning2D": {
      "name": "平面图形推理",
      "desc": "根据图例中两组灰框中的规律，推断并选出第三组灰框里问号处的图形",
      "tags": ["图形处理能力", "逻辑处理能力"],
      "hightlight": '2024真题题型',
    },
    "TextLogicalReasoning": {
      "name": "文字推理",
      "desc": "根据文字规则推断问号处的正确答案",
      "tags": ["逻辑处理能力", "阅读理解"],
      "hightlight": '2025新题型',
    },
    "PlaneTurntable": {
      "name": "平面转盘",
      "desc": "根据转盘旋转线索推断图形与颜色的对应关系",
      "tags": ["逻辑处理能力", "图形处理能力"],
      "hightlight": "2025新题型",
      "describe": [
        "大圆盘有 4 种颜色，小圆盘有 4 种图形，初始时一一对应。",
        "题面给出一个图形被转到某个颜色的位置（线索），旋转角度都是 90 度的整数倍。",
        "请判断其他图形分别对应哪种颜色。"
      ],
      link: ""
    },
    "StereoSameEdge": {
      "name": "立体同边",
      "desc": "判断折叠成立方体后两支箭头是否能接在一起",
      "tags": ["空间想象力", "逻辑处理能力"],
      "hightlight": "2025新题型",
      "describe": [
        "题目给出一个立方体展开图，并在其中两个方格画出箭头。",
        "将展开图折叠成立方体后，判断两支箭头是否能够接在一起。"
      ],
      link: ""
    },
    "GraphMatch": {
      "name": "图形匹配",
      "desc": "从选项中找出可与图例拼成完整方阵的图形（含旋转）",
      "tags": ["图形处理能力", "空间想象力"],
      "hightlight": "2025新题型",
      "describe": [
        "题干给出一个方阵图形，选项给出候选补图。",
        "请选择能和题干拼成完整方阵的选项，旋转后匹配也算正确。"
      ],
      link: ""
    },
    "CircuitRouting": {
      "name": "电路布线配对",
      "desc": "判断三组元件能否在网格中完成不交叉的电路连接",
      "tags": ["逻辑推理", "空间规划", "路径判断"],
      "hightlight": "2026新题型",
      "describe": [
        "每题会给出三组需要配对的元件，以及一个 5×5 网格。",
        "请判断三组元件能否同时用横向或纵向线路连接；线路不可交叉、不可共用网格，也不能穿过其他元件。"
      ],
      link: ""
    },
    "HarderMoss": {
      "name": "摩斯密码(4位)",
      "desc": "根据图例摩斯密码特征，选择出题目中的符号代码",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2022、2023真题题型',
      "describe": [
        '题目中，上方有由 "." "|" "-" 三种元素组合而成 10 种符号，每组符号对应不同的代码。下方 4 个符号取自于上方的 10 种符号，请你尽可能的快得找到下方 4 个符号对应的代码，并进行勾选。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E9%AB%98%E7%BA%A7%E8%8E%AB%E6%96%AF-new.mp4'
    },
    "FlashDiamond": {
      "name": "舒尔特方格闪图",
      "desc": "据九宫格的闪烁顺序的规则，对左边的原始图形进行变化，选出变化后的图形",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2021真题题型',
      "describe": [
        '每个题目，左侧为初始图形，右侧是九宫格的变化规则表，点击开始后，九宫格将会闪动。请根据右侧就功能给个的闪烁顺序，对应到中间的变化规则表，对左边的原始图形进行变化，选出变化后的图形。',
        '注意：',
        '（1）点击“开始”按钮启动九宫格闪烁，开始作答',
        '（2）“开始”按钮每题只能点击一次，九宫格也只会闪烁一遍，每题仅有一次作答机会',
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E8%88%92%E5%B0%94%E7%89%B9-new.mp4'
    },
    "E808A": {
      "name": "E808A1消失",
      "desc": "观察短暂出现的AB两个图例，在选项中选择与AB任意一个相同（包含旋转后）",
      "tags": ["图形处理能力", "记忆力"],
      "hightlight": '2019真题题型难度升级',

      "describe": [
        '题目中，点击“展示图例”按钮，左侧会展示出两个由红绿蓝颜色组成的三角形，中间是圆环，颜色为红绿蓝中的一个颜色。',
        '观察并记住左侧两个图形，从右边选项中选出与左侧图例颜色分布颜色规律完全相同的图形， 并且包含旋转后的图形。',
        '本题为多选题，请在保证正确性的情况下尽快作答。',
        '注意：每个题仅能查看一次图例，图例显示时间为 3 秒'
      ]
    },
    "E808B": {
      "name": "E808B1",
      "desc": "根据条件，判断各边与对角符号的颜色是否相同",
      "tags": ["逻辑处理能力", "记忆力"],
      "hightlight": '2019真题题型',
      "describe": [
        '题目中，能看到 12 组图形，图形有红绿蓝三种颜色，并由三角、圆圈及符号组成。',
        '本题需要观察三角形各边与对角符号的颜色及中间圆圈的颜色。',
        '规则如下：',
        '1. 若各边与对角的颜色三组全部相同（3同），中间圆圈是红色——选"1"，中间圆圈不是红色——选"01"',
        '2. 若各边与对角的颜色一组相同，中间圆圈是绿色——选"2"，中间圆圈不是绿色——选"02"',
        '3. 若各边与对角的颜色都不相同，中间圆圈是蓝色——选"3"，中间圆圈不是蓝色——选"03"',
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/e808b-new.mp4'
    },
    "E808B2": {
      "name": "E808B2",
      "desc": "判断相邻图形各边及符号颜色是否相同",
      "tags": ["逻辑处理能力", "记忆力"],
      describe: [
        '题目中，能看到 12 个图形，图形有红绿蓝三种颜色，并由三角及符号组成。每两个图形中间有两行选项，选项为 0、1、3。',
        '规则如下：',
        '1. 相邻两图三角形的边的颜色，全不同涂0，一个相同涂1，三个相同涂3，在第一行中进行选择。',
        '2. 相邻两图的符号形状，全不同涂0，一个相同涂1，三个相同涂3，，在第二行中进行选择。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/e808b2-new.mp4'
    },
    "Moss5": {
      "name": "摩斯密码(5位)",
      "desc": "根据图例摩斯密码特征，选择出题目中的符号代码",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '摩斯题型难度升级'
    },
    "E808B3": {
      "name": "E808C1 完整三角形分类",
      "desc": "根据三角形的分类规则，为下方的三角形进行分类，填写分类编号",
      "tags": ["逻辑处理能力", "记忆力"],
      "hightlight": '2022、2023真题题型',
      describe: [
        '题目中，能看到 12 个图形，图形有红绿蓝三种颜色，并由三角、圆圈及符号组成。三角形三边颜色分别为红绿蓝其中一个，无重复。三角形顶角的符号为加号、除号、竖除号其中一个，无重复。',
        '本题中三角形缺一边，三角形顶角缺一个符号，需要自行想象补齐。每两个图形中间有两行选项，选项为 0、1、3。',
        '规则如下：',
        '1. 同涂0，一个相同涂1，三个相同涂3，在第一行中进行选择。',
        '2. 相邻两图的符号形状，全不同涂0，一个相同涂1，三个相同涂3，，在第二行中进行选择。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/e808c-new.mp4'
    },
    "E808B4": {
      "name": "E808C2 缺失三角形分类",
      "desc": "根据分类规则，边及符号每种颜色仅出现一次，对三角形进行分类",
      "tags": ["逻辑处理能力", "记忆力"],
      "hightlight": '2019、2023真题难度升级'
    },
    "RandomForest": {
      "name": "随机森林",
      "desc": "找到与题目中的立体图形完全相同，只是呈现的角度不同的选项",
      "tags": ["图形处理能力", "逻辑处理能力"]
    },
    "E808APlus": {
      "name": "E808A1",
      "desc": "观察AB两个图例，在选项中选择与A、B任意一个相同（包含旋转后）的选项",
      "tags": ["图形处理能力"],
      "hightlight": '2019真题题型',
      "describe": [
        '题目中，左侧会给出两个由红绿蓝颜色组成的三角形，中间是圆环，颜色为红绿蓝中的一个颜色，从右边选项中选出与左侧图例颜色分布颜色规律完全相同的图形， 并且包含旋转后的图形。',
        '本题为多选题，请在保证正确性的情况下尽快作答。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E4%B8%8D%E5%8F%98-e808a-new.mp4'
    },
    "E808E": {
      "name": "E808A2消失",
      "desc": "根据短暂出现的图例，选出与图例区三角形的颜色完全相同的答案（包含旋转后相同）",
      "tags": ["图形处理能力", "记忆力"],
      "hightlight": '2021真题题型',
    },
    "SequenceBacktracking": {
      "name": "序列回溯",
      "desc": "屏幕上会随机出现0-9数字，判断当前数字与上上个数字相同/不相同",
      "tags": ["记忆力"],
      "hightlight": '2024真题题型'
    },
    "F3DScaleC": {
      "name": "F3D量表C",
      "desc": "找到与左侧图形相同的图形，奇偶行特殊符号下点击右方格",
      "tags": ["图形处理能力", "记忆力"]
    },
    "E808C": {
      "name": "E808B3",
      "desc": "观察相邻两图三角形的边的颜色，进行分类",
      "tags": ["逻辑处理能力", "记忆力"]
    },
    "E808D": {
      "name": "E808D1 三角形计算",
      "desc": "根据正三角形不同位置、颜色代表的数字，进行数值计算",
      "tags": ["逻辑处理能力", "计算能力"],
      "hightlight": '2021真题题型',
      describe: [
        '题目中，能看到 5 个彩色的三棱锥的俯视图，三棱锥四个面，分别为红绿黄蓝，无重复颜色。',
        '规则如下：',
        '1. 红色表示数字 1，绿色表示数字 2，蓝色表示数学 3，黄色表示数字 4；',
        '2. 正三角形的位置解构：正面的正三角形的数字表达为 1，左侧面的数字表达为 2，右侧面的数字表达为 3，底面的数字表达为 4；',
        '计算正三角体的正面和底面两个正三角形颜色乘位置的计算结果之和，填入图形下方输入框中。',
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/e808d-new.mp4'
    },
    "CodeMath": {
      name: "代码计算",
      tags: ['计算能力', '记忆力'],
      desc: '题目中每个图形代表一个数字，请根据图形算式选择正确的计算结果',
      "hightlight": '2019真题题型'
    },
    "StereoProjection": {
      name: "立体投影",
      tags: ["图形处理能力"],
      desc: '根据正方体四周视角，找到俯视视角下第二层的视图'
    },
    "F3DScaleB": {
      "name": "F3D量表B",
      "desc": "找到与左侧图形相同的图形，特殊符号下点击右方格",
      "tags": ["图形处理能力", "记忆力"]
    },
    "F3DScaleA": {
      "name": "F3D量表A",
      "desc": "找到与左侧图形相同的图形，并点击左方格",
      "tags": ["图形处理能力", "记忆力"]
    },
    "Seesaw": {
      name: "跷跷板",
      tags: ['计算能力', '逻辑处理能力'],
      desc: '观察题干跷跷板的状态来推断不同图案的轻重关系',
      "hightlight": '2023真题题型'
    },
    "FastMemory": {
      "name": "快速记忆",
      "desc": "在选项中找到题目中出现过的图形",
      "tags": ["记忆力"],
      "hightlight": '记忆能力自主基础练习'
    },
    "LogicalTransformerSector": {
      "name": "扇形变换",
      "desc": "根据短暂出现的指示规则进行图形处理",
      "tags": ["图形处理能力", "记忆力"]
    },
    "TaiChiA": {
      "name": "八卦图A",
      "desc": "找到与左侧图形相同的图形",
      "tags": ["图形处理能力", "记忆力"]
    },
    "QuickScale": {
      "name": "E808A快速量表",
      "desc": "答题界面左边的图形横向展示",
      "tags": ["图形处理能力", "记忆力"]
    },
    "TaiChiB": {
      "name": "八卦图B",
      "desc": "找到与左侧图形相同的图形，奇偶行特殊符号下点击右方格",
      "tags": ["图形处理能力", "记忆力"]
    },
    "E808D2": {
      "name": "E808C3 三角形纠错",
      "desc": "根据规则图例规则，找到示例三角形错误的符号与颜色",
      "tags": ["逻辑处理能力", "记忆力"],
      "hightlight": '2019、2023真题题型'
    },
    "PriceCalculate": {
      name: "价值换算",
      tags: ['计算能力', '逻辑处理能力'],
      desc: '观察题干的价值组合来推断不同图案的价值，然后据此判断选项中的哪个选项成立'
    },
    "E808EPlus": {
      "name": "E808A2",
      "desc": "请在答题区选出与图例区的颜色完全相同的答案（包含旋转后相同）。",
      "tags": ["图形处理能力"],
      "hightlight": '2019、2021真题题型'
    },
    "WhackAMole": {
      "name": "打地鼠",
      "desc": "观察记住地鼠出现的规律，打击地鼠",
      "tags": ["记忆力"],
      "hightlight": '2022真题题型',
      "describe": [
        '在题目开始之前，屏幕中会出现四个方框，代表地鼠可能会出现的四个位置。',
        '通过控制鼠标移动棒槌，在任意格子内轻点鼠标及敲打棒槌，则本轮测试开始。在每次敲打棒槌后，地鼠会在四个格子当中的一个格子内出现。若地鼠在刚刚点击过的格子内出现。则说明本次预测成功，地鼠被击中，格子上方也会出现点赞的表情，以示鼓励。若敲打后地鼠未在该格子内出现，则说明本次预测不成功，地鼠未被击中格子上方，出现哭脸表情。',
        '地鼠出现的次序都具有一定的规律，发现并记住这个规律，更好的预测下一次地鼠出现的位置。敲击成功你将会得到一分。',
        '连续敲击，直至本轮结束，结束时将弹出弹窗，点击确认将进入下一轮。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E6%89%93%E5%9C%B0%E9%BC%A0-new.mp4'
    },
    "FillWall": {
      "name": "立体补墙",
      "desc": "找到选项中的某个立方体的一面恰好可以从墙的正面完全填补这个空缺",
      "tags": ["图形处理能力"],
      "hightlight": '2020真题题型',
      "describe": [
        '每个题目，左侧会呈现一个5*5*1的墙面，中间有小立方体缺损，请仔细观察题目中墙面空缺的部分，在下面 4 个选项中选出一个立方体，它的任意一面恰好可以从墙的正面完全填补这个空缺。',
        '请在保证正确性的情况下尽快作答。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E7%AB%8B%E4%BD%93%E8%A1%A5%E5%A2%99-new.mp4'
    },
    "CubeComplement": {
      "name": "立方体补集",
      "desc": "找出能与题目中的立体结构恰好拼成一个正方体（即长宽高都相同）的互补结构",
      "tags": ["图形处理能力"],
      "hightlight": '2021真题题型',
      "describe": ['每个题目，左侧会呈现一个3*3*3的几何体的一部分，你需要先观察左侧的立方体结构，然后在右侧 8 个选项中找出能与之恰好拼成一个拼成一个3*3*3正方体（即长宽高都相同）的互补结构。',
        '请在保证正确性的情况下尽快作答。'],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E7%AB%8B%E6%96%B9%E4%BD%93%E8%A1%A5%E9%9B%86-new.mp4'
    },
    "LogicalTransformerSectorPlus": {
      "name": "扇形变换Plus",
      "desc": "根据短暂出现的图例和指示规则进行图形处理",
      "tags": ["图形处理能力", "记忆力"]
    },
    "MossMissing5": {
      "name": "摩斯密码(5位)消失",
      "desc": "根据限时出现的图例摩斯密码特征，选择出题目中的符号代码",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '摩斯题型难度升级'
    },
    "MossMissing4": {
      "name": "摩斯密码(4位)消失",
      "desc": "根据限时出现的图例摩斯密码特征，选择出题目中的符号代码",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2023真题题型难度升级'
    },
    "BlackWhiteDot": {
      "name": "黑白子",
      "desc": "根据每一行的处理逻辑，找到最终的图形",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2021真题题型改编'
    },
    "StereoscopicSection": {
      "name": "3D切面(学习模式)",
      "desc": "自主学习，查看不同立体形体的不同角度、位置的剖面图",
      "tags": ["图形处理能力"],
      "hightlight": '2024真题题型'
    },
    "ImageTransform": {
      "name": "图形变换",
      "desc": "根据正确规则和顺序变化找到最终的图形组合",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2020真题题型',
      "describe": [
        '每个题目，会有 8 个符号及其对应的规则，下方有四行图形变换题目，题目中第一个为初始图形，需要按照从左到右、从上到下的顺序，依次根据符号规则对其前面的图形进行操作。在选项中选出变换后的图形。每题只有1个正确答案。',
        '注意：',
        '（1）当图形带有多个操作符号时，根据先后顺序对图形进行连续变换；',
        '（2）后面的操作是基于前面变化后的图形进行的。'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E5%9B%BE%E5%BD%A2%E5%8F%98%E6%8D%A2-new.mp4'
    },
    "MossCopy": {
      "name": "摩斯密码(3位)消失",
      "desc": "根据限时出现的图例摩斯密码特征，选择出题目中的符号代码",
      "tags": ["记忆力", "图形处理能力"],
      "hightlight": '2022真题题型难度升级',
      "describe": [
        '题目中，点击“显示题目”，可以看到由 "." "|" "-" 三种元素组合而成的 10 种符号，每组符号对应不同的数字,请你尽可能的记住屏幕中显示的符号特征及相应的代码。',
        '下方 4 个符号取自于上方的 10 种符号，请你尽可能快、准确的根据符号特征选择符号代码，并进行勾选。',
        '注意：每题仅能查看一次图码表，图例显示时间为 8 秒'
      ],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E6%B6%88%E5%A4%B1-%E8%8E%AB%E6%96%AF-new.mp4'
    },
    "LogicalReasoning": {
      "name": "图形推理",
      "desc": "观察题目的图形，找到规律并预测正确的图形",
      "tags": ["图形处理能力", "记忆力"],
      "hightlight": '历年多次考察',
      "describe": ['本题整体考察的是根据图形变化找到图形变化规律的能力，比如有类比推理、九宫格推理、空间推理等。需要仔细阅读题目要求，根据题面寻找规律，并根据规律推断出最终答案。'],
      link: 'https://sjxzc.oss-cn-beijing.aliyuncs.com/video/%E5%9B%BE%E5%BD%A2%E6%8E%A8%E7%90%86-new.mp4'
    },
    "LogicalTransformer2D": {
      "name": "平面变换推理",
      "desc": "根据题面中操作1-操作4对应的变换过程，选出图例最终的变换后的结果",
      "tags": ["记忆力", "图形处理能力", "逻辑处理能力"],
      "hightlight": '2023真题题型'
    },
    "Unfolding3D": {
      "name": "立体展开图",
      "desc": "选出展开图中对应的立体图的字母",
      "tags": ["图形处理能力"],
      "hightlight": '2019、2024真题题型'
    },
     "Knot": {
      "name": "立体纽结",
      "desc": "找出一个无法被解开的绳结",
      "tags": ["图形处理能力"],
      "hightlight": '2025真题题型'
    },
  }
};
